export default __webpack_public_path__ + "static/media/boatman.11753e24.png";